import CONSTANTS from '@components-shared/constants';
import { trackEventWithDataInTrackingSystem } from '@utils/errors';
import { localStorageAvailability } from '@utils/localStorageAvailability.util';

class ReferralTokenService {
  getToken = (captchaIsEnabled: boolean): string | null => {
    const { REFERRAL_TOKEN_PARAMETER_NAME } = CONSTANTS;

    let referralToken: string | null = null;

    // Specially added for old browsers in the Referral Token feature. No need to cover other places
    // In some other cases browsers block access to localStorage.
    if (localStorageAvailability.isAvailable({ registerExceptionInTrackingSystem: false })) {
      referralToken = localStorage.getItem(REFERRAL_TOKEN_PARAMETER_NAME) || null;

      trackEventWithDataInTrackingSystem('Getting referral token from local storage', {
        token: referralToken,
        typeOfStorage: typeof Storage,
        captchaIsEnabled,
      });
    } else {
      const token = window.location.search.match(/token=(.*)/);

      if (token) {
        referralToken = token[1];
      }

      trackEventWithDataInTrackingSystem('Getting referral token from url', {
        token: referralToken,
        captchaIsEnabled,
      });
    }

    return referralToken;
  };
}

export const referralTokenService = new ReferralTokenService();
